import React from 'react';

const C = {
  bg: '#fbfaf6',
  ink: '#1a2a26',
  inkMuted: '#5a6b65',
  inkFaint: '#8b9690',
  line: '#e8e2d4',
  accent: '#2d6e58',
};

const PrivacyPage: React.FC = () => (
  <div style={{ background: C.bg, minHeight: '100vh', fontFamily: 'system-ui, sans-serif', color: C.ink }}>
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px' }}>
      <a href="/" style={{ color: C.accent, textDecoration: 'none', fontSize: 14 }}>← Back to Nice Agenda</a>
      <h1 style={{ marginTop: 32, marginBottom: 8, fontSize: 32, fontWeight: 700 }}>Privacy Policy</h1>
      <p style={{ color: C.inkFaint, fontSize: 14, marginBottom: 40 }}>Effective date: April 30, 2026</p>

      <Section title="1. Information We Collect">
        We collect information you provide directly, including your name, email address, and clinic details
        when you create an account. We also collect client data you enter into the Service (such as patient
        names, contact information, and appointment records) and usage data generated as you interact with
        the platform.
      </Section>

      <Section title="2. How We Use Your Information">
        We use the information we collect to: provide and improve the Service; send appointment reminders
        and notifications; process payments through our billing partner Paddle; respond to support requests;
        and comply with legal obligations. We do not sell your personal data to third parties.
      </Section>

      <Section title="3. Client Data You Enter">
        Any personal data about your clients that you input into Nice Agenda is processed on your behalf.
        You remain the data controller for that information and are responsible for ensuring you have a
        lawful basis to process it under applicable law (e.g., LGPD, GDPR, HIPAA as relevant to
        your jurisdiction).
      </Section>

      <Section title="4. Payment Processing">
        Payments are processed by Paddle (paddle.com), our authorized merchant of record. Nice Agenda does
        not store credit card numbers or payment instrument details. Paddle's privacy policy governs
        the handling of your payment information.
      </Section>

      <Section title="5. WhatsApp Integration">
        If you use the WhatsApp messaging feature, message content and recipient phone numbers are
        processed to deliver appointment reminders. We do not use this data for marketing or share
        it with unauthorized parties.
      </Section>

      <Section title="6. Data Retention">
        We retain your account data for as long as your account is active or as needed to provide
        the Service. You may request deletion of your account and associated data by contacting us.
        Some data may be retained for legal or accounting purposes after deletion.
      </Section>

      <Section title="7. Security">
        We implement industry-standard technical and organizational measures to protect your data.
        However, no method of transmission over the internet is 100% secure, and we cannot guarantee
        absolute security.
      </Section>

      <Section title="8. Your Rights">
        Depending on your jurisdiction, you may have rights to access, correct, export, or delete
        your personal data. To exercise these rights, contact us at the address below.
      </Section>

      <Section title="9. Cookies">
        We use essential cookies required for authentication and session management. We do not use
        advertising or tracking cookies.
      </Section>

      <Section title="10. Changes to This Policy">
        We may update this Privacy Policy periodically. We will notify you of significant changes
        via email or a notice within the Service.
      </Section>

      <Section title="11. Contact">
        For privacy-related inquiries, please contact us at{' '}
        <a href="mailto:pedro@bajotto.com" style={{ color: C.accent }}>pedro@bajotto.com</a>.
      </Section>
    </div>
  </div>
);

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div style={{ marginBottom: 32 }}>
    <h2 style={{ fontSize: 18, fontWeight: 600, color: C.ink, marginBottom: 8 }}>{title}</h2>
    <div style={{ borderTop: `1px solid ${C.line}`, paddingTop: 12 }}>
      <p style={{ color: C.inkMuted, lineHeight: 1.7, margin: 0, fontSize: 15 }}>{children}</p>
    </div>
  </div>
);

export default PrivacyPage;
